import { Theme, styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { appBarHeight, drawerWidths } from './BasePanel';

export const getStyles = (theme: Theme) => ({
  drawerPaper: {
    width: drawerWidths.xl,
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: drawerWidths.md,
    },
  },
  drawerPaperAnchorDockedLeft: {
    borderRight: 'none',
  },
  drawerChild: {
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'absolute',
    top: `${appBarHeight}px`,
    bottom: 0,
    width: '100%',
  },
  paper: {
    position: 'relative',
    padding: theme.spacing(8),
    borderRadius: '16px',
  },
  widePaper: {
    position: 'relative',
    padding: theme.spacing(4),
    borderRadius: '16px',
  },
});

export const SheetRoot = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: `${appBarHeight}px`,
  left: drawerWidths.xl,
  right: 0,
  bottom: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: theme.spacing(3, 0),
  [theme.breakpoints.down('md')]: {
    left: drawerWidths.md,
  },
}));

export const SheetMotionContainer = styled(motion.div)({
  position: 'absolute',
  width: '100%',
  height: '100%',
  overflowX: 'hidden',
});
